import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { createSuburbanOffersHistorySpoilerMapper, TMappedResponse } from './mappers';
import { IThunkContext } from '../../../types/redux';
import {
  fetchPublicSuburbanV1GetOffersHistorySpoiler,
  IPublicSuburbanV1GetOffersHistorySpoilerRequest,
} from '../../../repositories/valuation-offer-history/suburban/v1/get-offers-history-spoiler';

export const fetchSuburbanOffersHistorySpoiler = async (
  context: IThunkContext,
  parameters: IPublicSuburbanV1GetOffersHistorySpoilerRequest,
) => {
  try {
    const res = (await fetchPublicSuburbanV1GetOffersHistorySpoiler({
      httpApi: context.httpApi,
      parameters,
      mappers: createSuburbanOffersHistorySpoilerMapper(parameters),
    })) as TMappedResponse;

    if (res instanceof Error) {
      throw res;
    }

    return res;
  } catch (error) {
    if (error instanceof HttpBadStatusCodeError) {
      context.logger.debug('suburban/v1/get-offers-history-spoiler BadRequest', { details: error.printDetails() });
    } else {
      context.logger.error(error, { message: 'Error in suburban/v1/get-offers-history-spoiler', ...parameters });
    }

    throw error;
  }
};
